export const getProductPrice = (product) => {
  // Add null/undefined checks
  if (
    !product ||
    !product.price ||
    !product.price.price_list ||
    !Array.isArray(product.price.price_list) ||
    product.price.price_list.length === 0
  ) {
    return 0;
  }

  const requiredQty = product.required_qty || 1;
  let matchingPriceSlab = null;

  // Find the highest applicable price slab (highest min_qty that's still <= requiredQty)
  for (let i = 0; i < product.price.price_list.length; i++) {
    const priceSlab = product.price.price_list[i];
    if (priceSlab && priceSlab.min_qty <= requiredQty) {
      // Keep the highest applicable price slab
      if (!matchingPriceSlab || priceSlab.min_qty > matchingPriceSlab.min_qty) {
        matchingPriceSlab = priceSlab;
      }
    }
  }

  return matchingPriceSlab ? matchingPriceSlab.price : 0;
};

export const formatPrice = (price, decimals = 2) => {
  return price.toFixed(decimals);
};

export const getCartTotal = (cart) => {
  let subTotal = 0;
  for (let i = 0; i < cart.length; i++) {
    const price = getProductPrice(cart[i]);
    subTotal += parseFloat(cart[i].required_qty * price);
  }

  subTotal = formatPrice(subTotal);

  const gst = formatPrice((subTotal * 18) / 100);

  const total = formatPrice(parseFloat(subTotal) + parseFloat(gst));

  return { subTotal, total, gst };
};
